import { useEffect, useState } from 'react'
import { MultiSelect } from 'primereact/multiselect'
import './Dropdown.scss'
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

const FirmDropdownMenu = (props: { selected: any; setSelected: any; firmList: any; onFocus: any; getData: any }) => {
  const { t } = useTranslation()
  const [isPanelOpen, setIsPanelOpen] = useState(false)
  const [selectedItemList, setSelectedItemList] = useState(props.selected)

  useEffect(() => {
    setSelectedItemList(props.selected)
  }, [props.selected])

  const panelHeaderTemplate = (options: any) => {
    if (options) {
      return (
        <div>
          <div className="d-flex justify-content-between panelHeader">
            <div className="search p-input-icon-left">
              <i className="p-multiselect-filter-icon">{options.filterElement.props.children[1]}</i>
              <InputText
                className="multiselect-input"
                placeholder={t('input-texts.search-firm')}
                value={options.filterElement.props.children[0].props.value}
                onChange={options.filterElement.props.children[0].props.onChange}
              />
            </div>
          </div>

          {options.props.filterValue === '' && (
            <div className="selectAll">
              <Checkbox
                checked={options.checked}
                inputId="selectAll"
                onChange={options.onChange}
                className="select-all-checkbox"
              />
              <label htmlFor="selectAll" style={{ cursor: 'pointer', marginLeft: '8px' }}>
                ({t('input-texts.all-firms')})
              </label>
            </div>
          )}
        </div>
      )
    }
  }
  const selectedItemTemplate = (options: any) => {
    if (options) {
      return (
        <>
          <div className="selectedItem">
            <span className="selectedText">{options.name}</span>
            <i
              className="pi pi-times closeButton"
              onClick={() => {
                const filtered = selectedItemList.filter((item: any) => item.id !== options.id)
                setSelectedItemList(filtered)
              }}></i>
          </div>
        </>
      )
    }
  }
  const panelFooterTemplate = (options: any) => {
    const selectedItems = selectedItemList
    const length = selectedItems.length

    if (options) {
      return (
        <>
          <p className="py-2 px-3 footerText">
            <b>{length}</b> {t('dashboard.firm-chosen')}
          </p>
          <div className="d-flex justify-content-between">
            <Button
              label={t('buttons.clear')}
              className="mb-2 ms-2 btn-multiselect"
              onClick={() => setSelectedItemList([])}
              disabled={selectedItems.length === 0}
            />
            <Button
              disabled={!length}
              label={t('buttons.apply')}
              className="mb-2 me-2 btn-multiselect"
              onClick={(e) => {
                props.setSelected(selectedItems)
                props.getData(selectedItems)
                options.onCloseClick(e)
              }}
            />
          </div>
        </>
      )
    }
  }

  const onShow = () => setIsPanelOpen(true)
  const onHide = () => {
    setSelectedItemList(props.selected)
    setIsPanelOpen(false)
  }

  const _options = props?.firmList?.filter((item: any) => item.id !== null)

  return (
    <div className="listdropdown">
      <div className="card" style={{ position: 'relative' }}>
        <MultiSelect
          value={selectedItemList}
          disabled={props.firmList.length === 1}
          options={_options}
          display="chip"
          panelHeaderTemplate={panelHeaderTemplate}
          selectedItemTemplate={selectedItemTemplate}
          filter={true}
          className="multiselect"
          removeIcon="pi pi-times"
          selectAll={true}
          resetFilterOnHide={true}
          filterLocale="en"
          filterPlaceholder={t('input-texts.search-firm')}
          emptyFilterMessage={t('dashboard.no-firm-found')}
          optionLabel="name"
          panelStyle={{ width: '360px' }}
          panelFooterTemplate={panelFooterTemplate}
          placeholder={t('input-texts.firm-choice')}
          scrollHeight={'200px'}
          onChange={(e) => setSelectedItemList(e.value)}
          selectedItemsLabel={
            selectedItemList.length === props.firmList.length
              ? t('input-texts.all-location-chosen')
              : selectedItemList.length + ' ' + t('dashboard.firm-chosen')
          }
          maxSelectedLabels={1}
          dropdownIcon={isPanelOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
          onShow={onShow}
          onHide={onHide}
          onFocus={props.onFocus}
        />
      </div>
    </div>
  )
}

export default FirmDropdownMenu
